import axios from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import actionLibraryInstancesApi from 'config/api/actionLibraryInstance/actionLibraryInstance';
import type { ActionLibraryInstanceExportParams } from 'config/api/actionLibraryInstance/actionLibraryInstance.types';
import { getAxiosErrorUserMessage, triggerBlobDownload } from 'helpers/instanceExportDownload/instanceExportDownload';
import action_library_messages from 'messages/action_library_messages';

const useAssetActionInstanceExport = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation((params: ActionLibraryInstanceExportParams) => actionLibraryInstancesApi.exportActionLibraryInstances(params), {
    onSuccess: ({ data }) => {
      triggerBlobDownload(data.blob, data.filename);
    },
    onError: async (err: unknown) => {
      if (axios.isAxiosError(err) && err.response?.status === 403) {
        enqueueSnackbar(t(action_library_messages.instance.export.forbidden), { variant: 'error' });
        return;
      }
      const message = await getAxiosErrorUserMessage(err, t(action_library_messages.instance.export.failed));
      enqueueSnackbar(message, { variant: 'error' });
    },
  });
};

export default useAssetActionInstanceExport;
